import 'suneditor/dist/css/suneditor.min.css';
import 'antd/dist/antd.min.css';
import { UpOutlined } from '@ant-design/icons';
import { Spin, BackTop, notification } from 'antd';
import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import AppRoute from './routes/routes';
import { BrowserRouter } from 'react-router-dom';
import Header from './components/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import * as UserDataService from './services/GetUserData';
import * as Actions from './store/actions/user';
import store from './store';
import { WEBSITE_URL } from './Helper';


// Read initial preference directly from persist:root to handle the fraction of a second before Redux hydrates on page reload.
let initialPref = null;
try {
  const persistRoot = localStorage.getItem('persist:root');
  if (persistRoot) {
    const rootState = JSON.parse(persistRoot);
    const userState = rootState.User ? JSON.parse(rootState.User) : null;
    initialPref = userState?.userDetails?.preferred_date_format;
  }
} catch (e) {}

// Global Moment.js interceptor to dynamically adapt formats to the user's preferred format
const originalFormat = moment.fn.format;
moment.fn.format = function (formatStr) {
  if (formatStr === 'MM-DD-YYYY' || formatStr === 'MM/DD/YYYY') {
    const state = store.getState();
    const pref = state?.User?.userDetails?.preferred_date_format || initialPref;
    if (pref === 'DD/MM/YYYY') {
      return originalFormat.call(this, 'DD/MM/YYYY');
    } else if (pref === 'MM/DD/YYYY') {
      return originalFormat.call(this, 'MM/DD/YYYY');
    }
  }
  return originalFormat.call(this, formatStr);
};


const { Content } = Layout;

function App() {
  var dispatch = useDispatch();
  const [isLoading, setisLoading] = useState(false);
  const userDetails = useSelector((state) => state?.User?.userDetails);
  const isPublicRoute = 
    window.location.pathname.startsWith('/view-media/') || 
    window.location.pathname.startsWith('/shared-report/') ||
    window.location.pathname.startsWith('/reports/shared/');
  const getUserDetails = () => {
    dispatch(UserDataService.getUserData())
      .then((res) => {
        dispatch(Actions.set_user_auth(res));
        if ((res?.expired === true || res?.remaining_inspections <= 0) && res?.user_role !== 'um_dealer') {
          window.location.href = `${WEBSITE_URL}/plan-expired`;
        }
        if (
          res?.membersdhip_level === '7' ||
          res?.user_role === 'um_retailer'
        ) {
          window.location.href = `${WEBSITE_URL}/`;
        }
        if (res?.companycam_token) {
          localStorage.setItem('companycam_token', res.companycam_token);
        }
      })
      .catch((err) => {
        // Extract and display a meaningful error message
        let errorMessage;

        if (err.response) {
          console.error(err);
          // The request was made and the server responded with a status code outside of the 2xx range
          //errorMessage = `Error ${err.response.status}: ${err.response.data.message || err.response.statusText}`;
        } else if (err.request) {
          // The request was made but no response was received
          errorMessage = "No response received from the server. Please check your network connection.";
        } else {
          // Something else happened while setting up the request
          errorMessage = `An unexpected error occurred: ${err.message}`;
        }

        // Display the error message in an alert or use a UI notification component
        notification.error({ message: 'Error', description: errorMessage });
        handleLogout(); // Call the logout function
      });
  };
  const handleLogout = () => {
    // Clear tokens or session data
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('fd_backend_token');
    sessionStorage.clear();

    // Redirect to the logout route
    window.location.href = `${WEBSITE_URL}/logout/`;
  };
  const validateToken = async () => {
    try {
      const response = await dispatch(UserDataService.validateToken());
      console.log({ response });
      return true; // Return true if the token is valid
    } catch (err) {
      // Extract and display a meaningful error message
      let errorMessage;

      if (err.response) {
        console.error(err);
        errorMessage = "No response received from the server. Please check your network connection.";
        // The request was made and the server responded with a status code outside the 2xx range
        //errorMessage = `Error ${err.response.status}: ${err.response.data.message || err.response.statusText}`;
      } else if (err.request) {
        // The request was made but no response was received
        errorMessage = "No response received from the server. Please check your network connection.";
      } else {
        // Something else happened while setting up the request
        errorMessage = `An unexpected error occurred: ${err.message}`;
      }

      // Use a proper notification component instead of alert
      console.error(errorMessage);
      notification.error({ message: 'Token Validation Error', description: errorMessage });

      handleLogout(); // Call the logout function
      return false; // Return false if the token is invalid
    }
  };

  useEffect(() => {
    // Clean up legacy local storage key
    localStorage.removeItem('preferred_date_format');
    
    setisLoading(true);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let tokenVal = params.get('token');
    let laraveltokenVal = params.get('laravel_token');
    let localTokenItem = localStorage.getItem('jwt_token');
    
    if (laraveltokenVal) {
      localStorage.setItem('fd_backend_token', laraveltokenVal);
    }
    if (tokenVal) {
      localStorage.setItem('jwt_token', tokenVal);
      getUserDetails();
      window.history.pushState({}, document.title, '/');
    } else if (isPublicRoute) {
      // Allow public routes without a token
      setisLoading(false);
      return; 
    } else {
      if (localTokenItem && validateToken()) {
        if (!userDetails) {
          getUserDetails();
        }
      } else {
        window.location.href = `${WEBSITE_URL}/logout/`;
      }
    }

    setisLoading(false);
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // Microsoft Clarity
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "vrf1z6wq5o");

  return (
    <>
      {isLoading ? (
        <div className="isloading">
          <Spin className="spinDiv fullHeight" />
        </div>
      ) : (
        <BrowserRouter>
          <Layout>
            {!isPublicRoute && <Header />}
            <Content>
              <AppRoute />
            </Content>
            {!isPublicRoute && <Footer />}
            <BackTop className="backToTop">
              <UpOutlined />
            </BackTop>
          </Layout>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
